'use strict'

const BASIC_DEVICE_SEARCH_FETCH_SUCCESS = 'BASIC_DEVICE_SEARCH_FETCH_SUCCESS';
const BASIC_DEVICE_SEARCH_FETCH_REQUEST = 'BASIC_DEVICE_SEARCH_FETCH_REQUEST';
const BASIC_DEVICE_SEARCH_FETCH_FAILURE ='BASIC_DEVICE_SEARCH_FETCH_FAILURE';
const BASIC_DEVICE_SEARCH_RESET_NO_DATA_FOUND = "BASIC_DEVICE_SEARCH_RESET_NO_DATA_FOUND";

const DEVICE_HEART_BEAT_FETCH_SUCCESS = "DEVICE_HEART_BEAT_FETCH_SUCCESS";
const DEVICE_HEART_BEAT_FETCH_REQUEST = "DEVICE_HEART_BEAT_FETCH_REQUEST";
const DEVICE_DEMOGRAPHICS_FETCH_SUCCESS = "DEVICE_DEMOGRAPHICS_FETCH_SUCCESS";
const DEVICE_DEMOGRAPHICS_FETCH_REQUEST = "DEVICE_DEMOGRAPHICS_FETCH_REQUEST";
const DEVICE_DEMOGRAPHICS_FETCH_FAILURE = "DEVICE_DEMOGRAPHICS_FETCH_FAILURE";

const BASIC_DEVICE_SEARCH_FETCH_ACCESS_DENIED = "BASIC_DEVICE_SEARCH_FETCH_ACCESS_DENIED";

const DEVICE_RECENT_ASSAY_FETCH_SUCCESS = "DEVICE_RECENT_ASSAY_FETCH_SUCCESS";
const DEVICE_RECENT_ASSAY_FETCH_REQUEST = "DEVICE_RECENT_ASSAY_FETCH_REQUEST";
const DEVICE_RECENT_ASSAY_FETCH_FAILURE = "DEVICE_RECENT_ASSAY_FETCH_FAILURE";

const DEVICE_LATEST_LOT_ALL_ASSAY_SUCCESS = "DEVICE_LATEST_LOT_ALL_ASSAY_SUCCESS";
const DEVICE_LATEST_LOT_ALL_ASSAY_REQUEST = "DEVICE_LATEST_LOT_ALL_ASSAY_REQUEST";
const DEVICE_LATEST_LOT_ALL_ASSAY_FAILURE =   "DEVICE_LATEST_LOT_ALL_ASSAY_FAILURE";

const DEVICE_METRIC_RECENT_DATETIME_SUCCESS = "DEVICE_METRIC_RECENT_DATETIME_SUCCESS";
const DEVICE_METRIC_RECENT_DATETIME_REQUEST = "DEVICE_METRIC_RECENT_DATETIME_REQUEST";
const DEVICE_METRIC_RECENT_DATETIME_FAILURE = "DEVICE_METRIC_RECENT_DATETIME_FAILURE";

const FILE_ACCESS_MODAL_CONTROL = "FILE_ACCESS_MODAL_CONTROL";

const DEVICE_EVENT_DETAILS_FETCH_REQUEST = "DEVICE_EVENT_DETAILS_FETCH_REQUEST";
const DEVICE_EVENT_DETAILS_FETCH_SUCCESS = "DEVICE_EVENT_DETAILS_FETCH_SUCCESS";
const DEVICE_EVENT_DETAILS_FETCH_FAILURE = "DEVICE_EVENT_DETAILS_FETCH_FAILURE";

const FETCH_ALLOWED_MODELS_FOR_METERING_REQUEST = "FETCH_ALLOWED_MODELS_FOR_METERING_REQUEST";
const FETCH_ALLOWED_MODELS_FOR_METERING_SUCCESS = "FETCH_ALLOWED_MODELS_FOR_METERING_SUCCESS";
const FETCH_ALLOWED_MODELS_FOR_METERING_FAILURE = "FETCH_ALLOWED_MODELS_FOR_METERING_FAILURE";

const UPDATE_DEVICE_METERING_STATUS_REQUEST = "UPDATE_DEVICE_METERING_STATUS_REQUEST";
const UPDATE_DEVICE_METERING_STATUS_SUCCESS = "UPDATE_DEVICE_METERING_STATUS_SUCCESS";
const UPDATE_DEVICE_METERING_STATUS_FAILURE = "UPDATE_DEVICE_METERING_STATUS_FAILURE";
const FETCH_TRIGGER_ACTIVITY = "FETCH_TRIGGER_ACTIVITY";
const FETCH_TRIGGER_AUDIT_COUNT = "FETCH_TRIGGER_AUDIT_COUNT";

const GET_MAINTENANCE_DOMAINS_REQUEST = "GET_MAINTENANCE_DOMAINS_REQUEST";
const GET_MAINTENANCE_DOMAINS_SUCCESS = "GET_MAINTENANCE_DOMAINS_SUCCESS";
const GET_MAINTENANCE_DOMAINS_FAILURE = "GET_MAINTENANCE_DOMAINS_FAILURE";
const GET_MAINTENANCE_DATA_REQUEST = "GET_MAINTENANCE_DATA_REQUEST";
const GET_MAINTENANCE_DATA_SUCCESS = "GET_MAINTENANCE_DATA_SUCCESS";
const GET_MAINTENANCE_DATA_FAILURE = "GET_MAINTENANCE_DATA_FAILURE";
const GET_MAINTENANCE_DETAILS_REQUEST = "GET_MAINTENANCE_DETAILS_REQUEST";
const GET_MAINTENANCE_DETAILS_SUCCESS = "GET_MAINTENANCE_DETAILS_SUCCESS";
const GET_MAINTENANCE_DETAILS_FAILURE = "GET_MAINTENANCE_DETAILS_FAILURE";

const GET_SUPPORTED_FEATURES_REQUEST = "GET_SUPPORTED_FEATURES_REQUEST";
const GET_SUPPORTED_FEATURES_SUCCESS = "GET_SUPPORTED_FEATURES_SUCCESS";
const GET_SUPPORTED_FEATURES_FAILURE = "GET_SUPPORTED_FEATURES_FAILURE";
const CLEAR_INSTRUMENT_INSTANCE = "CLEAR_INSTRUMENT_INSTANCE";

export {
	BASIC_DEVICE_SEARCH_FETCH_SUCCESS,
	BASIC_DEVICE_SEARCH_FETCH_REQUEST,
	BASIC_DEVICE_SEARCH_FETCH_FAILURE,
	BASIC_DEVICE_SEARCH_RESET_NO_DATA_FOUND,
	DEVICE_HEART_BEAT_FETCH_SUCCESS,
	DEVICE_HEART_BEAT_FETCH_REQUEST,
	DEVICE_DEMOGRAPHICS_FETCH_SUCCESS,
	DEVICE_DEMOGRAPHICS_FETCH_REQUEST,
	DEVICE_DEMOGRAPHICS_FETCH_FAILURE,
	BASIC_DEVICE_SEARCH_FETCH_ACCESS_DENIED,
	DEVICE_RECENT_ASSAY_FETCH_SUCCESS,
	DEVICE_RECENT_ASSAY_FETCH_REQUEST,
	DEVICE_RECENT_ASSAY_FETCH_FAILURE,
	DEVICE_LATEST_LOT_ALL_ASSAY_SUCCESS,
	DEVICE_LATEST_LOT_ALL_ASSAY_REQUEST,
    DEVICE_LATEST_LOT_ALL_ASSAY_FAILURE,
	DEVICE_METRIC_RECENT_DATETIME_SUCCESS,
	DEVICE_METRIC_RECENT_DATETIME_REQUEST,
	DEVICE_METRIC_RECENT_DATETIME_FAILURE,
	FILE_ACCESS_MODAL_CONTROL,
	DEVICE_EVENT_DETAILS_FETCH_REQUEST,
    DEVICE_EVENT_DETAILS_FETCH_SUCCESS,
    DEVICE_EVENT_DETAILS_FETCH_FAILURE,
	FETCH_ALLOWED_MODELS_FOR_METERING_REQUEST,
	FETCH_ALLOWED_MODELS_FOR_METERING_SUCCESS,
	FETCH_ALLOWED_MODELS_FOR_METERING_FAILURE,
	UPDATE_DEVICE_METERING_STATUS_REQUEST,
	UPDATE_DEVICE_METERING_STATUS_SUCCESS,
	UPDATE_DEVICE_METERING_STATUS_FAILURE,
	FETCH_TRIGGER_ACTIVITY,
	FETCH_TRIGGER_AUDIT_COUNT,
	GET_MAINTENANCE_DOMAINS_REQUEST,
	GET_MAINTENANCE_DOMAINS_SUCCESS,
	GET_MAINTENANCE_DOMAINS_FAILURE,
	GET_MAINTENANCE_DATA_REQUEST,
	GET_MAINTENANCE_DATA_SUCCESS,
	GET_MAINTENANCE_DATA_FAILURE,
	GET_SUPPORTED_FEATURES_REQUEST,
	GET_SUPPORTED_FEATURES_SUCCESS,
	GET_SUPPORTED_FEATURES_FAILURE,
	GET_MAINTENANCE_DETAILS_REQUEST,
	GET_MAINTENANCE_DETAILS_SUCCESS,
	GET_MAINTENANCE_DETAILS_FAILURE,
	CLEAR_INSTRUMENT_INSTANCE
}
